module.exports = __webpack_public_path__ + "img/shengxin.46a66038.png";